/* 95til Fit Maker: flat-lay outfit builder. Goes with sections/95til-fit-maker.liquid */
(function () {
  'use strict';
  if (window.__nineFitLoaded) return; window.__nineFitLoaded = true;

  var NS = 'http://www.w3.org/2000/svg';
  var KEY = '95til-fit';
  var NONE = { id: 'none', kind: 'none', title: 'Top only', bottom: true, price: 0, variants: [] };

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function isOpen(p) { return !p.sealed || store('95til-sealed:' + p.handle) === '1'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var n = (cents || 0) / 100;
    function f(d, t, dec) { var p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? dec + p[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
      return f(2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  function hex2rgb(h) { h = (h || '#F47735').replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); var n = parseInt(h, 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
  function shade(h, amt) { var c = hex2rgb(h).map(function (v) { return Math.max(0, Math.round(v * (1 - amt))); }); return 'rgb(' + c.join(',') + ')'; }
  function inkFor(h) { var c = hex2rgb(h); return (c[0] * 299 + c[1] * 587 + c[2] * 114) / 1000 > 128 ? '#181715' : '#F3EFE7'; }

  function groupOf(p) {
    if (p.sealed) return 'Places';
    if (p.bottom) return 'Bottoms';
    var t = p.title.toLowerCase();
    if (p.kind === 'hoodie') return t.indexOf('box logo') > -1 ? 'Box Logo hoodies' : 'Hoodies';
    return 'Graphic tees';
  }
  var ORDER = ['Box Logo hoodies', 'Hoodies', 'Graphic tees', 'Places', 'Bottoms'];

  // Layout shared by the on-screen SVG and the saved image. Units: 400 x 860.
  function layout(top, bot) {
    var tw = { hoodie: 300, ls: 300, tee: 322 }[top.kind] || 310;
    var th = tw * top.h / top.w;
    var bw = 0, bh = 0;
    if (bot.kind === 'joggers') { bh = 400; bw = bh * bot.w / bot.h; if (bw > 300) { bw = 300; bh = bw * bot.h / bot.w; } }
    else if (bot.kind === 'shorts') { bw = 236; bh = bw * bot.h / bot.w; }
    var overlap = bot.kind === 'none' ? 0 : (top.kind === 'hoodie' ? 0.2 : 0.16);
    var total = th * (1 - overlap) + bh;
    var y0 = Math.max(20, (840 - total) / 2), botY = y0 + th * (1 - overlap);
    return {
      top: { x: 200 - tw / 2, y: y0, w: tw, h: th, rot: -1.8, cy: y0 + th / 2 },
      bot: bh ? { x: 200 - bw / 2, y: botY, w: bw, h: bh, rot: 1.6, cy: botY + bh / 2 } : null
    };
  }

  function init(root) {
    if (root.dataset.fmReady) return; root.dataset.fmReady = '1';
    var data; try { data = JSON.parse(root.querySelector('.fm-data').textContent); } catch (e) { console.error('Fit Maker data', e); return; }
    var items = (data.items || []).filter(function (p) { return p && p.img; });
    items.forEach(function (p) { p.group = groupOf(p); });
    var BY = {}; items.forEach(function (p) { BY[p.id] = p; });
    var tops = items.filter(function (p) { return !p.bottom; });
    var bots = items.filter(function (p) { return p.bottom; });
    var fmt = data.currency;

    var svg = root.querySelector('.fm-fig'), list = root.querySelector('.fm-list'), lines = root.querySelector('.fm-lines');
    var sum = root.querySelector('.fm-sum'), add = root.querySelector('.fm-add'), noEl = root.querySelector('.fm-no');
    var sheet = root.querySelector('.fm-sheet');

    if (!tops.length) { list.innerHTML = '<p>Pick the Rack and Places collections in this section’s settings.</p>'; add.disabled = true; return; }

    var saved = {}; try { saved = JSON.parse(store(KEY) || '{}') || {}; } catch (e) { saved = {}; }
    var state = { tab: 'top', top: null, bottom: null, sizes: saved.sizes || {}, no: saved.no || 95, unlocking: null };
    function okTop(id) { var p = BY[id]; return p && !p.bottom && isOpen(p); }
    function okBot(id) { return id === 'none' || (BY[id] && BY[id].bottom); }
    var openTops = tops.filter(isOpen);
    state.top = okTop(saved.top) ? saved.top : (openTops[0] || tops[0]).id;
    state.bottom = okBot(saved.bottom) ? saved.bottom : (bots[0] ? bots[0].id : 'none');

    function getP(id) { return id === 'none' ? NONE : BY[id]; }
    function persist() { store(KEY, JSON.stringify({ top: state.top, bottom: state.bottom, sizes: state.sizes, no: state.no })); }
    function pad(n) { return ('0000' + n).slice(-4); }

    // ---------- stage ----------
    function el(tag, attrs, parent) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); if (parent) parent.appendChild(n); return n; }
    function draw() {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var top = getP(state.top), bot = getP(state.bottom), L = layout(top, bot);
      var f = el('filter', { id: 'fmsh-' + root.id, x: '-10%', y: '-10%', width: '120%', height: '125%' }, el('defs', {}, svg));
      el('feDropShadow', { dx: 0, dy: 8, stdDeviation: 9, 'flood-color': '#000', 'flood-opacity': 0.55 }, f);
      var fu = 'url(#fmsh-' + root.id + ')';
      if (L.bot) {
        var bg = el('g', { filter: fu, transform: 'rotate(' + L.bot.rot + ' 200 ' + L.bot.cy + ')' }, svg);
        el('image', { href: bot.img, x: L.bot.x, y: L.bot.y, width: L.bot.w, height: L.bot.h, preserveAspectRatio: 'xMidYMid meet' }, bg);
      }
      var tg = el('g', { filter: fu, transform: 'rotate(' + L.top.rot + ' 200 ' + L.top.cy + ')' }, svg);
      el('image', { href: top.img, x: L.top.x, y: L.top.y, width: L.top.w, height: L.top.h, preserveAspectRatio: 'xMidYMid meet' }, tg);
      if (data.sticker) el('image', { href: data.sticker, x: 326, y: 14, width: 56, height: 57, opacity: 0.92, transform: 'rotate(8 354 42)' }, svg);
      svg.setAttribute('aria-label', 'Fit: ' + top.title + (bot.kind === 'none' ? '' : ' with ' + bot.title));
      noEl.textContent = 'FIT No. ' + pad(state.no);
    }

    // ---------- closet ----------
    function mailerHTML(p) {
      var c = p.color || '#F47735';
      return '<span class="fm-mailer" style="--mc:' + esc(c) + ';--md:' + shade(c, 0.14) + ';--mink:' + inkFor(c) + '">' +
        '<img data-nine-seal="' + esc(c) + '" alt="" width="300" height="305"><span>' + esc(p.label) + '</span></span>';
    }
    function tileHTML(p) {
      var sealed = !isOpen(p);
      var sel = (state.tab === 'top' ? state.top : state.bottom) == p.id;
      var pic, nm, pr;
      if (p.kind === 'none') {
        pic = '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="14" fill="none" stroke="currentColor" stroke-width="2" opacity=".5"/><path d="M10 30 30 10" stroke="currentColor" stroke-width="2" opacity=".5"/></svg>';
        nm = 'Top only'; pr = 'No bottoms';
      } else if (sealed) {
        pic = mailerHTML(p); nm = 'Sealed'; pr = p.label;
      } else {
        pic = '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="' + p.w + '" height="' + p.h + '">';
        nm = p.title; pr = p.priceText;
      }
      return '<button type="button" class="fm-item" data-id="' + p.id + '" aria-pressed="' + sel + '"' +
        (sealed ? ' data-sealed-tile aria-label="Sealed ' + esc(p.label) + ' piece. Open the package to unlock."' : '') + '>' +
        '<span class="fm-pic">' + pic + '</span><span class="fm-nm">' + esc(nm) + '</span><span class="fm-pr">' + esc(pr) + '</span></button>';
    }
    function renderCloset() {
      root.querySelectorAll('.fm-tabs button').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.tab === state.tab); });
      var src = state.tab === 'top' ? tops : bots.concat([NONE]);
      var groups = {};
      src.forEach(function (p) { var g = p.kind === 'none' ? 'Bottoms' : p.group; (groups[g] = groups[g] || []).push(p); });
      var html = '';
      ORDER.forEach(function (g) {
        if (!groups[g]) return;
        html += '<div class="fm-group"><h3>' + esc(g === 'Places' ? 'Places (sealed until opened)' : g) + '</h3><div class="fm-items">';
        groups[g].forEach(function (p) {
          html += tileHTML(p);
          if (state.unlocking == p.id) {
            html += '<div class="fm-unlock" role="status"><p><b>Sealed.</b> Open the ' + esc(p.label) + ' package to add this piece to your fits. Once it’s open, it stays in your closet.</p>' +
              '<a class="button" href="' + esc(p.url) + '" data-open-pkg="' + p.id + '">Open the package</a></div>';
          }
        });
        html += '</div></div>';
      });
      list.innerHTML = html;
      if (window.nineFillSeals) window.nineFillSeals(list);
    }

    // ---------- receipt ----------
    function variantFor(p) {
      var v = p.variants.filter(function (x) { return x.id == state.sizes[p.id]; })[0];
      if (v && v.available) return v;
      v = p.variants.filter(function (x) { return x.available; })[0];
      return v || null;
    }
    function renderReceipt() {
      var pieces = [getP(state.top), getP(state.bottom)].filter(function (p) { return p && p.kind !== 'none'; });
      var total = 0, ok = true, html = '';
      pieces.forEach(function (p) {
        var v = variantFor(p);
        if (!v) ok = false;
        total += p.price;
        var sizes = '';
        if (p.variants.length > 1) {
          sizes = '<div class="fm-sizes" role="group" aria-label="Size for ' + esc(p.title) + '">' + p.variants.map(function (x) {
            return '<button type="button" data-p="' + p.id + '" data-v="' + x.id + '" aria-pressed="' + (v && v.id === x.id) + '"' + (x.available ? '' : ' disabled') + '>' + esc(x.title) + '</button>';
          }).join('') + '</div>';
        }
        html += '<li><span class="fm-thumb"><img src="' + esc(p.img) + '" alt="" width="' + p.w + '" height="' + p.h + '"></span>' +
          '<div class="fm-lname"><a href="' + esc(p.url) + '" style="color:inherit;text-decoration:none">' + esc(p.title) + '</a>' + (v ? '' : ' <span style="opacity:.6">(sold out)</span>') + sizes + '</div>' +
          '<span class="fm-price">' + esc(p.priceText) + '</span></li>';
      });
      lines.innerHTML = html;
      sum.textContent = money(total, fmt);
      add.disabled = !ok || !pieces.length;
      add.textContent = ok ? 'Add the fit to bag · ' + money(total, fmt) : 'A piece is sold out';
    }

    function render() { draw(); renderCloset(); renderReceipt(); persist(); }

    // ---------- events ----------
    root.querySelector('.fm-tabs').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-tab]'); if (!b) return;
      state.tab = b.dataset.tab; state.unlocking = null; renderCloset();
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('.fm-item'); if (!b) return;
      var p = getP(b.dataset.id === 'none' ? 'none' : +b.dataset.id); if (!p) return;
      if (b.hasAttribute('data-sealed-tile')) { state.unlocking = state.unlocking == p.id ? null : p.id; renderCloset(); return; }
      state.unlocking = null;
      if (p.bottom) state.bottom = p.id; else state.top = p.id;
      render();
    });
    lines.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]'); if (!b || b.disabled) return;
      state.sizes[b.dataset.p] = +b.dataset.v; renderReceipt(); persist();
    });
    root.querySelector('.fm-shuffle').addEventListener('click', function () {
      var t = tops.filter(isOpen), bb = bots.length ? bots : [NONE];
      if (t.length > 1) t = t.filter(function (p) { return p.id !== state.top; });
      state.top = t[Math.floor(Math.random() * t.length)].id;
      state.bottom = bb[Math.floor(Math.random() * bb.length)].id;
      state.no = 1 + Math.floor(Math.random() * 9998);
      state.unlocking = null; render();
    });

    function toast(html) {
      var t = root.querySelector('.fm-toast');
      if (!t) { t = document.createElement('div'); t.className = 'fm-toast'; t.setAttribute('role', 'status'); root.appendChild(t); }
      t.innerHTML = html; clearTimeout(t._h); t.hidden = false;
      t._h = setTimeout(function () { t.hidden = true; }, 4200);
    }

    add.addEventListener('click', function () {
      var pieces = [getP(state.top), getP(state.bottom)].filter(function (p) { return p && p.kind !== 'none'; });
      var lines2 = pieces.map(function (p) { var v = variantFor(p); return v && { id: v.id, quantity: 1 }; }).filter(Boolean);
      if (!lines2.length) return;
      var label = add.textContent; add.disabled = true; add.textContent = 'Adding…';
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines2, sections: 'cart-icon-bubble' })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
        .then(function (j) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && j.sections && j.sections['cart-icon-bubble']) {
            var d = new DOMParser().parseFromString(j.sections['cart-icon-bubble'], 'text/html');
            var s = d.querySelector('.shopify-section'); bubble.innerHTML = s ? s.innerHTML : d.body.innerHTML;
          }
          add.textContent = 'Added to bag';
          toast('Fit added. <a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart">View bag</a>');
          setTimeout(function () { add.disabled = false; renderReceipt(); }, 1600);
        })
        .catch(function (err) { add.disabled = false; add.textContent = label; toast(esc(err.message)); });
    });

    // ---------- save my fit ----------
    function loadImg(src) {
      return new Promise(function (res, rej) {
        var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = rej;
        i.src = src.indexOf('//') === 0 ? location.protocol + src : src;
      });
    }
    var shotURL = null, shotBlob = null;
    function makeShot() {
      var top = getP(state.top), bot = getP(state.bottom), L = layout(top, bot);
      var srcs = [top.img, L.bot ? bot.img : null, data.sticker || null];
      return Promise.all(srcs.map(function (s) { return s ? loadImg(s).catch(function () { return null; }) : null; })).then(function (imgs) {
        var W = 1080, H = 1920, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var g = cv.getContext('2d');
        g.fillStyle = '#181715'; g.fillRect(0, 0, W, H);
        g.fillStyle = 'rgba(243,239,231,.06)';
        for (var y = 30; y < H; y += 54) for (var x = 30; x < W; x += 54) { g.beginPath(); g.arc(x, y, 3, 0, 7); g.fill(); }
        var S = 800 / 400, OX = 140, OY = 150;
        function piece(img, r) {
          if (!img || !r) return;
          g.save(); g.translate(OX + 200 * S, OY + r.cy * S); g.rotate(r.rot * Math.PI / 180); g.translate(-(OX + 200 * S), -(OY + r.cy * S));
          g.shadowColor = 'rgba(0,0,0,.55)'; g.shadowBlur = 36; g.shadowOffsetY = 16;
          g.drawImage(img, OX + r.x * S, OY + r.y * S, r.w * S, r.h * S); g.restore();
        }
        piece(imgs[1], L.bot); piece(imgs[0], L.top);
        if (imgs[2]) { g.save(); g.globalAlpha = 0.92; g.translate(860, 200); g.rotate(8 * Math.PI / 180); g.drawImage(imgs[2], -80, -82, 160, 164); g.restore(); }
        var head = getComputedStyle(root).getPropertyValue('--font-heading-family') || 'sans-serif';
        var body = getComputedStyle(root).getPropertyValue('--font-body-family') || 'sans-serif';
        g.fillStyle = '#F3EFE7'; g.textBaseline = 'alphabetic';
        g.font = '900 64px ' + head; g.fillText('95TIL', 64, 110);
        g.fillStyle = '#a9a399'; g.font = '800 28px ' + head; g.textAlign = 'right'; g.fillText('FIT No. ' + pad(state.no), 1016, 104);
        g.textAlign = 'left'; g.fillStyle = '#F3EFE7'; g.font = '600 26px ' + body;
        var names = [top.title].concat(bot.kind === 'none' ? [] : [bot.title]).join('  +  ');
        g.fillText(names, 64, 1830, W - 128);
        g.fillStyle = '#a9a399'; g.font = '500 22px ' + body; g.fillText((location.host || '95til.com').replace(/^www\./, ''), 64, 1872);
        return new Promise(function (res) { cv.toBlob(function (b) { res(b); }, 'image/png'); });
      });
    }
    var lastFocus = null, eatUntil = 0;
    function openSheet() {
      lastFocus = document.activeElement;
      var saveBtn = root.querySelector('.fm-save'); saveBtn.disabled = true; saveBtn.textContent = 'Making it…';
      makeShot().then(function (b) {
        if (!b) throw new Error('blank');
        shotBlob = b; if (shotURL) URL.revokeObjectURL(shotURL); shotURL = URL.createObjectURL(b);
        sheet.querySelector('img').src = shotURL; sheet.hidden = false;
        sheet.querySelector('.fm-share').focus();
      }).catch(function (e) { console.error(e); toast('Couldn’t make the image. Try a screenshot instead.'); })
        .then(function () { saveBtn.disabled = false; saveBtn.textContent = 'Save my fit'; });
    }
    function closeSheet() { sheet.hidden = true; eatUntil = Date.now() + 600; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    document.addEventListener('click', function (e) { if (Date.now() < eatUntil && !root.contains(e.target)) { e.preventDefault(); e.stopPropagation(); } }, true);
    root.querySelector('.fm-save').addEventListener('click', openSheet);
    sheet.querySelector('.fm-done').addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    sheet.querySelector('.fm-share').addEventListener('click', function () {
      if (!shotBlob) return;
      var name = '95til-fit-' + pad(state.no) + '.png';
      var file = null; try { file = new File([shotBlob], name, { type: 'image/png' }); } catch (e) {}
      if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], title: '95til fit' }).catch(function () {});
        return;
      }
      var a = document.createElement('a'); a.href = shotURL; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    });

    // Come back from opening a package: refresh which pieces are unlocked.
    // Use each image's real proportions once it loads.
    items.forEach(function (p) {
      var i = new Image();
      i.onload = function () {
        if (!i.naturalWidth) return;
        var changed = Math.abs(p.w / p.h - i.naturalWidth / i.naturalHeight) > 0.01;
        p.w = i.naturalWidth; p.h = i.naturalHeight;
        if (changed && (p.id == state.top || p.id == state.bottom)) draw();
      };
      i.src = p.img;
    });

    // ---------- open a package right here ----------
    // Loads the product page's unboxing and plays it over the Fit Maker.
    // If anything goes wrong, the link just goes to the product page.
    var opening = null;
    function unlocked(p) {
      state.unlocking = null; state.tab = 'top'; state.top = p.id;
      render(); toast('Unlocked: ' + esc(p.title) + '. It’s in your closet now.');
    }
    function openHere(p, link) {
      if (opening || !window.nineSealedInit || !window.fetch || !window.DOMParser) return false;
      opening = p.id; link.textContent = 'Opening…'; link.setAttribute('aria-busy', 'true');
      var fail = function () { opening = null; location.href = p.url; };
      fetch(p.url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var src = doc.querySelector('[data-sealed]');
        if (!src) throw 0;
        var wrap = src.closest('.shopify-section') || src.parentNode;
        var holder = document.createElement('div');
        holder.className = 'fm-pkg';
        Array.prototype.forEach.call(wrap.children, function (n) { if (n.tagName !== 'SCRIPT') holder.appendChild(document.importNode(n, true)); });
        document.body.appendChild(holder);
        var r = holder.querySelector('[data-sealed]');
        var sk = r.querySelector('.sl-skip'); if (sk) sk.textContent = 'Skip';
        r.querySelectorAll('.sl-replay').forEach(function (b) { b.remove(); });
        var key = r.dataset.key;
        var onOpen = function (e) {
          if (!e.detail || e.detail.key !== key) return;
          document.removeEventListener('95til:sealed-opened', onOpen);
          setTimeout(function () {
            holder.remove(); opening = null;
            document.documentElement.classList.remove('sl-pending');
            unlocked(p);
          }, e.detail.animated ? 1250 : 50);
        };
        document.addEventListener('95til:sealed-opened', onOpen);
        document.documentElement.classList.add('sl-pending');
        window.nineSealedInit(r);
        if (window.nineFillSeals) window.nineFillSeals(holder);
      }).catch(fail);
      return true;
    }
    list.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-open-pkg]'); if (!a) return;
      var p = BY[a.dataset.openPkg]; if (!p) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (openHere(p, a)) e.preventDefault();
    });

    window.addEventListener('pageshow', function () { state.unlocking = null; renderCloset(); });

    render();
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-fit-maker]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();